/// <reference path="../../BaseNew/GAdmHromadnaOperaceBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class HromadnaOperaceAdmSpisovyUzelProPredavani extends GContentBase {
        private hromadnaOperaceObj: HromadnaOperaceAdmSpisovyUzelProPredavaniObj & GContent;
        private data: Gordic.AdmIsl.Interface.GAdmSpisovyUzelProPredavaniReadDto[];
        private keys: string[];

        onContentReady() {
            this.hromadnaOperaceObj = $.extend(this as GContent, new HromadnaOperaceAdmSpisovyUzelProPredavaniObj())
            this.hromadnaOperaceObj.createBase({
                title: "jres:33000623", //RC 33000623 : Hromadné přidání funkčních míst
                data: this.data,
                objectFields: ['ixs_su_txt'],
                serviceCnt: "Gordic.Adm.WebControls.HromadnaOperaceAdmSpisovyUzelProPredavani",
                keys: this.keys,
                contentId: "hromadnaOperaceAdmSpisovyUzelProPredavani "
            })
        }
    }

    export class HromadnaOperaceAdmSpisovyUzelProPredavaniObj extends GAdmHromadnaOperaceBase<Gordic.AdmIsl.Interface.GAdmSpisovyUzelProPredavaniReadDto> {
        isFunkcniMisto: boolean

        createForm(cnt: GContent<IGContentBase, any>, contentDiv: JQuery<HTMLElement>, change: OGWizardChange) {
            var form = new Gordic.Forms.Form({ layoutDescriptor: "L1M1S1" })
                .addRow("jres:33000917").addField("gselectbox", Gordic.Prefabs.Select.ginspod(), { //RC 33000917 : Spisové uzly
                    name: "ixs_su",
                    model: "model.ixs_su=value.ixs_su;model.ixs_su_txt<=value.nazev",
                    dropdown: false,
                    multi: true,
                    itemWidth: "",
                    initialValue: this.options.data.map((value) => ({ ixs_su: value.ixs_su })),
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    serverFilters: {
                        aktivita: this.getAllAktivita()
                    }
                }).addRow("jres:33000918").addField("gselectbox", Gordic.Prefabs.Select.ginspod(), { //RC 33000918 : Spisové uzly pro předání
                    name: "ixs_su_pre",
                    model: "model.ixs_su_pre=value.ixs_su;model.ixs_su_pre_txt<=value.nazev",
                    dropdown: false,
                    multi: true,
                    itemWidth: "",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    serverFilters: {
                        aktivita: this.getAllAktivita()
                    }
                }).addRow("jres:32131030").addField("gselectbox", Gordic.Prefabs.Select.gincakt(), {
                    name: "aktivita",
                    model: "model.aktivita=value.aktivita;model.aktivita_txt<=value.aktivita_txt",
                    initialValue: { aktivita: 100 },
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                })
            $("<div>").appendTo(contentDiv).gform("createFrom", form);
        }

        createDefineGridData(formData: any): any {
            var cartesianResult = this.createCartesianProduct2D(this.transformDataToArrayObject(formData, ["ixs_su", "ixs_su_txt"]), this.transformDataToArrayObject(formData, ["ixs_su_pre", "ixs_su_pre_txt"]));
            var resultArray: any = [];
            cartesianResult.forEach((item) => {
                var data = {
                    ixs_su: item[0]["ixs_su"],
                    ixs_su_txt: item[0]["ixs_su_txt"],
                    ixs_su_pre: item[1]["ixs_su_pre"],
                    ixs_su_pre_txt: item[1]["ixs_su_pre_txt"],
                    aktivita: formData['aktivita'],
                    aktivita_txt: formData['aktivita_txt']
                }
                resultArray.push(data);
            })
            return resultArray;
        }

        createGridFormat(gridFormat: Gordic.Data.GridFormat): Gordic.Data.GridFormat {
            gridFormat.addTextColumn({
                caption: "jres:29930955",
                name: "ixs_su_txt"
            }).addTextColumn({
                caption: "jres:33000919", //RC 33000919 : Spisový uzel pro předání
                name: "ixs_su_pre_txt"
            }).addTextColumn({
                caption: "jres:32131030",
                name: "aktivita_txt",
                editor: {
                    widget: "gselectbox",
                    options: $.extend(Gordic.Prefabs.Select.gincakt(), {
                        dropdown: true,
                        model: "model.aktivita=value.aktivita;model.aktivita_txt=value.aktivita_txt",
                        validators: [
                            new Gordic.Validators.Required({ stopping: true })
                        ]
                    })
                }
            })
            return gridFormat;
        }

        // Volání zatím přes CSharp (přes ISL zatím nevím jak na hromadné operace)
        saveData(data: any[]): JQueryPromise<any> {
            var saveData: Gordic.AdmIsl.Interface.GAdmSpisovyUzelProPredavaniSaveDto[] = [];
            data.forEach((item) => {
                saveData.push({
                    ixs_su: item['ixs_su'],
                    ixs_su_pre: item['ixs_su_pre'],
                    aktivita: item['aktivita'],
                    NewRecord: true
                })
            })
            return this.getServiceCnt().call("SaveHromadne", { saveData: saveData }).done((results) => {
                this.createResultData(results)
            })
        }

        validateRows(data: any): Gordic.Validators.GridError[] {
            return [];
        }

        testExistMethod(data: any[]): JQueryPromise<any> {
            return $.Deferred()
        }
    }
}